"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var error = _ref.palette.error;
  return {
    dayEl: {
      position: 'relative'
    },
    event: {
      position: 'absolute',
      bottom: 0,
      left: '50%',
      marginLeft: -2,
      width: 4,
      height: 4,
      borderRadius: '4px',
      backgroundColor: error.main
    }
  };
}, {
  name: 'EventsCalendar'
});
exports.useStyles = useStyles;